import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import { useReframe } from 'nike-re-framejs';

import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { loggedIn$ } from '@/account/subs';

function FavoriteButton({ active, disabled, onClick, className }) {
    const timeoutId = useRef();
    useEffect(() => () => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
    });
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!loggedIn) {
            PopupNg.dispatcher.open('dialog/login4action', { bodyText: i18n('favourite.notloggedin') });
            return;
        }
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        //500ms trva ripple animacia
        timeoutId.current = setTimeout(onClick, 500);
    }

    return (
        <button
            className={clsx('star-button mx-5 ripple', { active }, className)}
            disabled={disabled}
            onClick={handleClick}
            data-atid="favorite-icon"
        >
            <div className={active ? 'icon-star-active' : 'icon-star-inactive'} />
        </button>
    );
}

export default FavoriteButton;
